import contact from './contact/contact.middleware';
import group from './group/group.middleware';
import settings from './settings/settings.middleware';

export default [
    contact,
    group,
    settings
]